<template>
    <div ref="container">
        <slot />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    mounted() {
        this.$nextTick(() => {
            const container = this.$refs.container as HTMLElement;

            // Get all sups from the page
            const allSups = Array.from(document.querySelectorAll('sup'));

            // Filter out the ones that are inside this component
            const externalSups = allSups.filter(sup => {
                // If container contains the sup, return false (ignore it)
                return container && !container.contains(sup);
            });

            externalSups.forEach(sup => {
                // Check if we already added a link to avoid double-processing
                if (sup.querySelector('a[data-footnote-linked]')) return;

                const val = sup.textContent?.trim();

                if (val && /^\d+$/.test(val)) {
                    // 2. Add the data attribute when creating the element
                    sup.innerHTML = `<a href="#footnote-${val}"
                            class="cursor-pointer"
                            data-footnote-linked="true">${val}</a>`;
                }
            });
        });
    }
});
</script>
